// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function ExpandedSearchHoliday(parent) {
    var self = this;
    self.Bao = Bao;
    var htmlUrl = "ExpandedSearchSynoset/ExpandedHoliday";
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
            parent.ExpandedSearchVisible(true);
        });
    };
    self.ShowWaitForApproval = ko.observable();
    self.ShowWaitForApproval.subscribe(function () {
        if (self.ShowWaitForApproval() == true) {
            parent.CustomFilter(self.GetCustomFilter(true));
        }
        else {
            parent.CustomFilter(self.GetCustomFilter(false));
        }
    });
    self.HolidayApprovalState = ko.observable(1);
    self.HolidayApprovalState.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.Years = ko.observableArray([]);
    self.SelectedYear = ko.observable();
    self.SelectedYear.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ShowHolidaysOfAllApprovers = ko.observable(false);
    self.ShowHolidaysOfAllApprovers.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.GetCustomFilter = function () {
        var returnObject: any = {
            TicketStatusId: null,
            Year: null,
            ShowHolidaysOfAllApprovers: false
        };
        if (self.HolidayApprovalState() === "1") {
            returnObject.TicketStatusId = JSON.stringify("3a9a5ead-53ad-48d7-8ed4-abfa95516018");
        }
        else if (self.HolidayApprovalState() === "2") {
            returnObject.TicketStatusId = JSON.stringify("82eb2417-2708-4de7-8117-d1a52775b128");
        }
        else {
            returnObject.TicketStatusId = JSON.stringify(null);
        }
        if (self.SelectedYear() != null) {
            returnObject.Year = JSON.stringify(self.SelectedYear().year);
        }
        returnObject.ShowHolidaysOfAllApprovers = JSON.stringify(self.ShowHolidaysOfAllApprovers());
        return returnObject;
    };
    var Year = function (year) {
        this.year = year;
    };
    self.loadFilter = function () {
        return Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), function (result) {
            var currentDate = new Date();
            for (var r in result) {
                if (result[r].Key != "" && result[r].Key != null) {
                    var y = new Year(result[r].Key);
                    self.Years.push(y);
                    if (y.year == currentDate.getFullYear()) {
                        self.SelectedYear(y);
                    }
                }
            }
            var currentDate = new Date();
            self.SelectedYear(new Year(currentDate.getFullYear()));
        });
    };
    self.init = function () {
        return self.LoadHtml().then(function () {
            self.loadFilter();
        });
    };
}
export default ExpandedSearchHoliday;